const MONTHLY_GOAL = 32;

const LEVELS = [
  { min: 76, label: "Ritmo saludable"   },
  { min: 51, label: "Buen seguimiento"  },
  { min: 26, label: "Cobertura inicial" },
  { min: 0,  label: "Atención baja"    },
];

/**
 * Returns pastoral coverage percentage and a contextual label.
 * districtStats reserved for future richer models (active families, priorities, cycles).
 */
export function getPastoralCoverage(metrics, _districtStats = {}) {
  const completed = metrics?.completed ?? 0;
  const pct = Math.min(100, Math.round((completed / MONTHLY_GOAL) * 100));
  const { label } = LEVELS.find((l) => pct >= l.min) ?? LEVELS.at(-1);
  return { pct, label };
}
